export default __webpack_public_path__ + "images/4P.9255c4d.png";